import { gql } from "@apollo/client";

export const UPDATE_DOCUMENT_STATE = gql`
  mutation updateDocumentState($input: UpdateDocumentStateInput!) {
    updateDocumentState(input: $input) {
      commandId
      correlationId
    }
  }
`;
